/* KOMYT — formulaire waitlist → Klaviyo Client API · v1 2026-10-02
   - Abonnement à la liste (double opt-in géré par le réglage de la liste Klaviyo)
   - Propriétés profil : langue, formulaire source, UTM (attribution CPL par canal)
   - Événement Shopify "kmt_waitlist_signup" pour les pixels (Customer events)  */
(function () {
  if (window.__kmtWaitlist) return;
  window.__kmtWaitlist = true;

  var REVISION = '2026-01-15';
  var EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
  var UTM_KEYS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term'];

  function captureUtm() {
    var stored = {};
    try { stored = JSON.parse(sessionStorage.getItem('kmt_utm') || '{}'); } catch (e) {}
    try {
      var p = new URLSearchParams(window.location.search);
      UTM_KEYS.forEach(function (k) { if (p.get(k)) stored[k] = p.get(k).slice(0, 200); });
      if (!stored.landing_referrer && document.referrer) stored.landing_referrer = document.referrer.slice(0, 200);
      sessionStorage.setItem('kmt_utm', JSON.stringify(stored));
    } catch (e) {}
    return stored;
  }
  var UTM = captureUtm();

  function post(path, companyId, body) {
    return fetch('https://a.klaviyo.com/client/' + path + '/?company_id=' + encodeURIComponent(companyId), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'revision': REVISION },
      body: JSON.stringify(body)
    });
  }

  function init(wrap) {
    var form = wrap.querySelector('form');
    var input = wrap.querySelector('input[type="email"]');
    var btn = wrap.querySelector('button[type="submit"]');
    var err = wrap.querySelector('.kmt-error');
    var success = wrap.querySelector('.kmt-success');
    var hp = wrap.querySelector('.kmt-hp');
    if (!form || !input || !btn) return;
    var ds = form.dataset;
    var btnLabel = btn.textContent;

    function showError(msg) {
      err.textContent = msg; err.hidden = false;
      input.setAttribute('aria-invalid', 'true'); input.focus();
    }
    function clearError() {
      if (err.hidden) return;
      err.hidden = true; err.textContent = ''; input.removeAttribute('aria-invalid');
    }
    function busy(on) {
      btn.disabled = on; btn.setAttribute('aria-busy', on ? 'true' : 'false');
      btn.textContent = on ? ds.loading : btnLabel;
    }
    function done() {
      form.hidden = true; success.hidden = false; success.focus();
    }

    input.addEventListener('input', clearError);

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (btn.disabled) return;
      var email = input.value.trim().toLowerCase();
      if (hp && hp.value) { done(); return; }               // bot
      if (!EMAIL_RE.test(email)) { showError(ds.errInvalid); return; }
      if (!ds.company || !ds.list || ds.company.indexOf('XXXX') === 0) {
        console.error('[kmt] Clé publique ou ID de liste Klaviyo manquant (snippet kmt-waitlist-form).');
        showError(ds.errServer); return;
      }
      busy(true);

      var subscription = {
        data: {
          type: 'subscription',
          attributes: {
            custom_source: ds.source,
            profile: { data: { type: 'profile', attributes: { email: email } } }
          },
          relationships: { list: { data: { type: 'list', id: ds.list } } }
        }
      };

      post('subscriptions', ds.company, subscription)
        .then(function (res) {
          if (!res.ok) throw new Error('HTTP ' + res.status);
          // Propriétés profil (non bloquant)
          var props = { kmt_language: ds.locale, kmt_signup_form: ds.source, kmt_signup_page: window.location.pathname };
          Object.keys(UTM).forEach(function (k) { props['kmt_' + k] = UTM[k]; });
          post('profiles', ds.company, { data: { type: 'profile', attributes: { email: email, properties: props } } })
            .catch(function () {});
          // Événement pour les pixels Shopify (respecte le consentement côté Customer events)
          try {
            if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) {
              Shopify.analytics.publish('kmt_waitlist_signup', { form: ds.source, language: ds.locale });
            }
          } catch (x) {}
          try { localStorage.setItem('kmt_lang', ds.locale); } catch (x) {}
          done();
        })
        .catch(function (x) {
          console.error('[kmt] Klaviyo', x);
          showError(ds.errServer);
        })
        .then(function () { busy(false); });
    });
  }

  function boot() {
    document.querySelectorAll('[data-kmt-waitlist]').forEach(function (w) {
      if (w.__kmt) return; w.__kmt = true; init(w);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  // Éditeur de thème : réinitialiser quand une section est rechargée
  document.addEventListener('shopify:section:load', boot);
})();
